import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NgClass } from '@angular/common';

export interface ToastData {
  message: string;
  title?: string;
  type: 'error' | 'success' | 'warn' | 'info';
}

@Component({
  selector: 'app-toast-notification',
  imports: [NgClass],
  templateUrl: './toast-notification.component.html',
  styleUrl: './toast-notification.component.scss',
})
export class ToastNotificationComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
    public snackBarRef: MatSnackBarRef<ToastNotificationComponent>,
  ) {}

  dismiss(): void {
    this.snackBarRef.dismiss();
  }

  getDefaultTitle(type: 'error' | 'success' | 'warn' | 'info'): string {
    switch (type) {
      case 'error':
        return 'Error Occurred';
      case 'success':
        return 'Success';
      case 'warn':
        return 'Warning';
      case 'info':
        return 'Notice';
    }
  }
}
